module.exports = __webpack_public_path__ + "img/home.194cba1.png";